var path = 'app/scripts/modules/openstack/src/common/footer.directive.html';
var html = "<div class=\"modal-footer\">\n  <user-verification account=\"vm.account\" verification=\"vm.verification\"></user-verification>\n  <button type=\"submit\" ng-click=\"vm.action()\" style=\"display:none\"></button> <!-- Allows form submission via enter keypress-->\n  <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">Cancel</button>\n  <button type=\"submit\"\n          class=\"btn btn-primary\"\n          ng-click=\"vm.action()\"\n          ng-disabled=\"!vm.isValid()\">\n    Submit\n  </button>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/openstack/src/common/footer.directive.html
// module id = 1392
// module chunks = 0